import NBType from '@netbase/nb-type'
import Type from '../../enums/action/Type'
import Action from '../../enums/dispatch/Action'
import { QueryData, QueryDataType } from '../../utils/queryDataUtil'

const ActionSchema = NBType.object().shape('ActionSchema', {
  type: NBType.enum(Type),
  queryData: NBType.mixed<QueryDataType>().default(() => QueryData()), // TODO: goog.Uri.QueryData
  convertResult: NBType.mixed(), // function
  priority: NBType.number().default(Action.NORM_PRIORITY)
})
export default ActionSchema
// RESERVE BELOW
